var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"SermonsPage"}},[_c('Jumbotron',{attrs:{"heading":"Sermons","subheading":""}}),_c('b-container',[_c('b-row',[_c('div',{staticClass:"col-lg-8 blog-main pt-5"},[_c('AllSermons')],1),_c('Sidebar')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }